<template>
<div class="d-flex">
<div class="col-md-3 panel-details" >
    <div class="info-panel">
      <div class="panel-details">
      <div class="panel-details-head">
       <i class="fas fa-edit mr-2" ></i>INFORMAÇÕES
      </div>
       <div class="panel-details-body">
         <p class="subtitle">Dados Colaborador</p>
         <div class="d-flex mt-2">
          <div class="w-50">
            <p class="label">Colaborador</p>
            <p class="value">{{dataExpenseDetails.coordenador !== null || dataExpenseDetails.coordenador  !== undefined ? dataExpenseDetails.coordenador.nome : "N/D"}}</p>
          </div>
          <div>
            <p class="label">Codigo</p>
            <p class="value">{{dataExpenseDetails.coordenador !== null || dataExpenseDetails.coordenador  !== undefined ? dataExpenseDetails.coordenador.codigo : "N/D"}}</p>
          </div>
         </div>
         <div class="d-flex mt-3">
          <div class="w-50">
            <p class="label">Data</p>
          </div>
          <div>
            <p class="label">Obra</p>
            <p class="value">{{dataExpenseDetails.coordenador !== null || dataExpenseDetails.coordenador  !== undefined ? dataExpenseDetails.coordenador.obra : "N/D"}}</p>
          </div>
         </div>
         <p class="subtitle mt-3">Dados da Despesa</p>
         <div class="d-flex mt-3">
          <div class="w-50">
            <p class="label">Quantidade</p>
            <p class="value">{{dataExpenseDetails.quantidade}}</p>
          </div>
          <div>
            <p class="label">Valor</p>
            <p class="value">{{dataExpenseDetails.valorFormatado}}</p>
          </div>
         </div>
         <div class="d-flex mt-3">
          <div class="w-50">
            <p class="label">Categoria</p>
            <p class="value">{{dataExpenseDetails.categoriaDescricao}}</p>
          </div>
          <div>
            <p class="label">Serviço / Matéria</p>
            <p class="value">TEste</p>
          </div>
         </div>
         <p class="subtitle mt-3">Dados Colaborador</p>
         <div class="mt-3" v-for="(data,index) in dataExpenseDetails.funcionarioVinculados" :key="index">
            <p class="label">Código do funcionario {{index + 1}}</p>
            <p class="value">{{data.funcionario.nome}}</p>
          </div>
        </div>
    </div>
    <div class=" buttons-footer"  v-if="verificardisablechangeStatus">
      <button class="button-panel apr" @click="ApprovedDespesaByid"><i class="fas fa-thumbs-up"></i> APROVAR</button>
      <button class="button-panel rep" @click="DisaApprovedDespesaByid"><i class="fas fa-thumbs-down"></i> REPROVAR</button>
    </div>
    </div>
  </div>
  <div class="col-md-9 ">
    <div class="panel-info-details">
      <div class="panel-body">
         <DetailsHeader :titleHead="'Despesas De Viagem'" ref="DetailsHeader" :btnCanceSave="false"/>
         <div class="info-panel-details">
          <p class="subtitle">Dados da despesas</p>
          <div class="d-flex">
            <div class="col-md-2">
              <p class="label mb-2">Quantidade</p>
              <p class="value">{{dataExpenseDetails.quantidade}}</p>
            </div>
            <div class="col-md-2">
              <p class="label mb-2">Valor</p>
              <p class="value">{{dataExpenseDetails.valorFormatado}}</p>
            </div>
            <div class="col-md-3">
              <p class="label mb-2">Categoria</p>
              <p class="value">{{dataExpenseDetails.categoriaDescricao}}</p>
            </div>
            <div class="col-md-3">
              <p class="label mb-2">Sub Categoria</p>
              <p class="value">{{dataExpenseDetails.descriptionAllSubCategoria}}</p>
            </div>
            <div class="col-md-2">
              <p class="label mb-2">Status</p>
              <p class="value" :style="{'color': dataExpenseDetails.colorStatusDespesa, 'font-weight': 'bold' }">{{dataExpenseDetails.statusDespesaDescricao}}</p>
            </div>
          </div>
          <div class="d-flex mt-4">
            <div class="col-md-12 obs-heigth">
              <p class="label mb-2">Observação</p>
              <p class="value">{{dataExpenseDetails.observacao}}</p>
              </div>
          </div>
          <div class="d-flex mt-4">
            <div class="col-md-4">
              <div class="d-flex justify-content-between">
                <p class="subtitle">Funcionário Vinculados</p>
                <!-- <div id="add-more-people" @click="addfuncionario()"><i class="fas fa-plus-circle mr-1"></i>Adicionar</div> -->
              </div>
              <div v-for="(data,index) in dataExpenseDetails.funcionarioVinculados" :key="index" class="mb-3">
                <p class="label mb-2">Código do funcionario {{index + 1}}</p>
                <div class="d-flex">
                  <p class="value">{{data.funcionario.codigo + " - " +  " "}}</p>
                  <p class="value"> {{data.funcionario.nome}}</p>
                </div>
              </div>
            </div>
            <div class="ml-4 col-md-6">
              <p class="subtitle">Comprovante</p>
              <div class="interface-file" @click="showpdf" v-if="dataExpenseDetails.midia !== null || dataExpenseDetails.midia !== undefined">
                <i class="far fa-file-pdf"></i>
                <div class="edit-file"><i class="fas fa-edit"></i></div>
                <div class="footer-file">
                  {{dataExpenseDetails.midia.name === null || dataExpenseDetails.midia.name === undefined ? "N/D" : dataExpenseDetails.midia.name}}
                </div>
              </div>
            </div>
          </div>
         </div>
      </div>
    </div>
  </div>
  <b-modal ref="modal-showpdf"    hide-footer
            centered title="COMPROVANTE">
              <iframe
                style="overflow: hidden"
                id="testeFrame"
                scrolling="no"
                class="pdf-overview"
                :src="`${this.isPdf ? 'data:application/pdf' : 'data:image/png'};base64,`+ midiapdf  + '#toolbar=0&navpanes=0&scrollbar=0'" frameborder="0">
            </iframe>
  </b-modal>
</div>
</template>

<script>
import { loading } from '@/shared/utils/UIHelper'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import DetailsHeader from '@/views/private/realestate/components/HeadDetails.vue'

export default {
  name: 'Details',
  mixins: [ActionsForm],
  components: {DetailsHeader},
  props: ['dataExpenseDetails'],
  data () {
    return {
      despesaviagemid: null,
      midiapdf: null,
      isPdf: false,
      details: false
    }
  },
  mounted () {
    this.despesaviagemid = this.dataExpenseDetails.id
  },
  computed: {
    verificardisablechangeStatus: function () {
      if (this.dataExpenseDetails === null || this.dataExpenseDetails === undefined) return false
      if (parseInt(this.dataExpenseDetails.statusDespesa) < 3) return true
      return false
    }
  },
  methods: {
    ApprovedDespesaByid () {
      loading.push()
      TravelExpenseRepository.ApprovedDespesaByid(this.despesaviagemid)
        .then((Response) => {
          if (Response.status === 200) {
            this.dataExpenseDetails.colorStatusDespesa = Response.data.colorStatusDespesa
            this.dataExpenseDetails.statusDespesaDescricao = Response.data.statusDespesaDescricao
            this.dataExpenseDetails.statusDespesa = Response.data.statusDespesa
          }
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    DisaApprovedDespesaByid () {
      loading.push()
      TravelExpenseRepository.DisaApprovedDespesaByid(this.despesaviagemid)
        .then((Response) => {
          if (Response.status === 200) {
            this.dataExpenseDetails.colorStatusDespesa = Response.data.colorStatusDespesa
            this.dataExpenseDetails.statusDespesaDescricao = Response.data.statusDespesaDescricao
            this.dataExpenseDetails.statusDespesa = Response.data.statusDespesa
          }
          loading.pop()
        })
        .catch((Error) => {
          loading.pop()
        })
    },
    showpdf () {
      this.midiapdf = this.dataExpenseDetails.midia.arquivobyte
      let midiaName = this.dataExpenseDetails.midia.name
      this.isPdf = midiaName.includes('pdf')
      this.$refs['modal-showpdf'].show()
    }
  }

}
</script>

<style scoped>
.pdf-overview{
    height: 657px;
    width: 100%;
  }
 .panel-details {
    height: 80%;
}
 .info-panel-details{
    padding: 20px;
  }
  .panel-info-details{
    height: 75vh;
    padding: 15px;
    background: white;
  }
  .obs-heigth{
    min-height: 10vh;
  }
  .footer-file{
    bottom: 0px;
    height: 30px;
    color: rgb(163, 163, 163);
    width: 100%;
    border-radius: 0px 0px 10px 10px;
    background: #eceff1;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .edit-file{
    height: 25px;
    width: 40px;
    color: white;
    font-size: 12px;
    cursor: pointer;
    top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    right: 0px;
    background: #008144;
  }
  .interface-file {
    position: relative;
    color: #c8cbcc;
    height: 175px;
    cursor: pointer;
    border: 1px solid gainsboro;
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 60px;
    width: 275px;
  }
   .panel-body{
    border: 1px solid rgb(211, 210, 210);
    overflow: auto;
    border-radius: 10px;
    height: 100%;
  }
  .subtitle {
    font-size: 16px;
    font-weight: bold;
    color: #008144;
  }
  .buttons-footer{
    height: 25%;
    align-items: center;
    flex-direction:column ;
    display: flex;
  }
  .label{
    color: gray;
    line-height: 9px;
    font-weight: 500;
    padding: 0px;
    margin: 0px;
    font-size: 14px;
  }
  .value{
    color: black;
    font-weight: 600;
    padding: 0px;
    margin: 0px;
    font-size: 14px;
  }
  .apr{
    background: #008144;
  }
  .apr:hover{
    background: #03a358;
  }
  .rep{
    background: red;
  }
  .rep:hover{
    background: rgb(197, 3, 3);
  }
  .button-panel{
    width: 75%;
    color: white;
    margin-bottom: 10px;
    height: 40px;
    border: none;
    border-radius: 10px;
    font-weight: bold;
  }
  .info-panel {
    position: relative;
    height: 75vh;
    padding: 0px;
    background: white;
    border-radius: 10px;
  }
  .panel-details-head{
    height: 40px;
    background: #eceff1;
    padding-left: 15px;
    border-radius: 10px 10px 0px 0px;
    color: #008144;
    font-weight: bold;
    display: flex;
    align-items: center;
  }
  .panel-details-body{
    padding: 20px;
    overflow: auto;
    max-height: 90%;
  }
</style>



// WEBPACK FOOTER //
// src/views/private/finance/accountability/components/travelExpenseTab/components/boardtrevelexpenseemployee/components/details/details.vue